import { render, staticRenderFns } from "./CardSingleValue.vue?vue&type=template&id=348d97cd&"
import script from "./CardSingleValue.vue?vue&type=script&lang=js&"
export * from "./CardSingleValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports